import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TabContext from "@mui/lab/TabContext";
import {
  Collapse,
  Divider,
  GlobalStyles,
  IconButton,
  MenuItem,
  Slide,
  Typography,
  useTheme,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import * as React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DownloadJd,
  getJdFileList,
  getMatchedJdResumeData,
} from "../../../../api/Api";
import CandidateHub from "../../../../assets/icons/CandidateHub";
import CandidateSupportIco from "../../../../assets/icons/CandidateSupportIco";
import HeartIco from "../../../../assets/icons/HearIco";
import JobIco from "../../../../assets/icons/JobIco";
import PurposeScopeIco from "../../../../assets/icons/PurposeScopeIco";
import ReportBugIco from "../../../../assets/icons/ReportBugIco";
import SkillDrag from "../../../../assets/icons/SkillDrag";
import SowAssemptionIco from "../../../../assets/icons/SowAssemptionIco";
import SowFolderIco from "../../../../assets/icons/SowFolderIco";
import SowJudicaFolderIco from "../../../../assets/icons/SowJudicaFolderIco";
import SummaryIco from "../../../../assets/icons/SummaryIco";
import SupportIco from "../../../../assets/icons/SupportIco";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import CommonButton from "../../../../component/Button";
import DropDownSelect from "../../../../component/Select";
import SnackBar from "../../../../component/SnackBar";
import { LAYOUT } from "../../../../redux/Action";
import {
  ChatBotCall,
  ChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../../../redux/action/ChatBot";
import { FeedBackButton } from "../../../../redux/action/Feedback";
import { SowEnrichGetCall } from "../../../../redux/action/Ignite";
import {
  checkBackGroundProcess,
  GetJobDataDetail,
  JobCandidateResume,
  JobJobFormikData,
  JobJobSubmit,
  JobSummary,
} from "../../../../redux/action/Job";
import { MinimizeIcon } from "../../../../redux/action/Login";
import { UploadJob } from "../../../../redux/action/QuickMatch";
import { GET, GETDOWNLOAD } from "../../../../redux/axios/Axios";
import {
  HandleSkeletion,
  rebuildSourceFromFinalData,
} from "../../../../utils/constants";
import ChatBotLabelText from "../../../chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../../chat-bot/SIdeBarChatBot";
import { CustomDiv, HaileyButton } from "../../../chat-bot/style";
import {
  CommonGrid2,
  JudicaCandidateTabViewSection,
  JudicaTabViewSection,
  TabPanelView,
} from "../../../common-components/StyledComponents";
import DownloadJD from "../../../jobs/job-information/download-jd";
import JobsCandidate from "../../../jobs/jobs-candidate";
import DialogCandidateHub from "../../../jobs/jobs-candidate/components/DialogCandidateHub";
import JobsSummary from "../../../jobs/jobs-summary";
import { CommonTippy } from "../../../jobs/style";
import AddMoreCandidate from "../../../matches/quick-match/components/AddMoreCandidate";
import JemPlus from "./JemPlus";
import SowSummary from "./SowSummary";
import HaileyChatBotIco from "../../../../assets/icons/HaileyChatBotIco";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import HaileyCollapseIco from "../../../../assets/icons/HaileyCollapseIco";
import HaileyExpandIco from "../../../../assets/icons/HaileyExpandIco";
import useMeasure from "react-use-measure";

export default function Judica() {
  const location = useLocation();
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const theme = useTheme();
  const [value, setValue] = React.useState("1");
  const [jobData, setJobData] = React.useState({});
  const [openDownloadJdDialog, setOpenDownloadJdDialog] = React.useState(false);
  const [jdFileList, setJdFileList] = React.useState([]);
  const [jdFileListLoader, setJdFileListLoader] = React.useState(false);
  const dispatch = useDispatch();
  const [resumeTab, setResumeTab] = React.useState([]);
  const [resumeScore, setResumeScore] = React.useState([]);
  const resumeId = resumeTab[value - 3]?.id;
  const filteredResumeTab = [
    ...resumeTab,
    ...(jobData?.hiring_manager || []),
  ].filter((item) => item.id !== resumeId);
  const [matchedData, setMatchedData] = React.useState({});
  const [resumeLoader, setResumeLoader] = React.useState(false);
  const valueLocation = useLocation().search;
  const navigate = useNavigate();
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [isLoading, setIsLoading] = React.useState(false);
  const [tableLoader, setTableLoader] = React.useState(false);
  const [minimizeScreen, setMinimizeScreen] = React.useState(false);
  const gridRef = React.useRef(null);
  const [gridHeight, setGridHeight] = React.useState(null);
  const [addMoreCandidateDialogOpen, setAddMoreCandidateDialogOpen] =
    React.useState(false);
  const [isAddMoreCandidateDragging, setIsAddMoreCandidateDragging] =
    React.useState(false);
  const [addMoreCandidateFiles, setAddMoreCandidateFiles] = React.useState([]);
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [saveEditData, setSaveEditData] = React.useState({
    open: false,
    prevData: "",
    leaveLoading: false,
    disabled: false,
    saveLoading: false,
    view: false,
  });
  const [jobDropdown, setJobDropDown] = React.useState({
    data: {},
  });
  const [sowEnrichData, setSowEnrichData] = React.useState({
    data: {},
    loading: false,
  });
  const JobJobEditData = useSelector((state) => state.jobs.jobJobEditData);
  const tabData = [
    { name: "SOW Requirement", icon: <SowJudicaFolderIco /> },
    { name: "Summary", icon: <SummaryIco /> },
    { name: "Job", icon: <JobIco /> },
  ];
  const [open, setOpen] = React.useState(true);
  const questionMarkItemRef = React.useRef(null);
  const [backGroundprocess, setBackGroundprocess] = React.useState({
    open: false,
    disabled: false,
    openLoading: false,
    buttonLoading: false,
    hiringLoading: false,
    goldenLoading: false,
  });
  const [ref, bounds] = useMeasure();
  const [sowJudicaData, setSowJudicaData] = React.useState({
    data: {},
    loading: false,
  });
  const [chatBotData, setChatBotData] = React.useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubble: [],
    bubbleCondition: false,
    selectedValue: "Job",
    expandDrawer: false,
  });
  const [isBottomVisible, setIsBottomVisible] = React.useState(true);
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const sowSummary_clientInformation = [
    {
      icon: <SowFolderIco />,
      information: [
        {
          title: "Project Title",
          value: sowEnrichData.data?.client_information?.project_title || "-",
        },
        {
          title: "Client",
          value: sowEnrichData.data?.client_information?.client || "-",
        },
        {
          title: "Client Representative",
          value:
            sowEnrichData.data?.client_information?.client_representative ||
            "-",
        },
      ],
    },
    {
      icon: <PurposeScopeIco />,
      purpose: [
        {
          title: "Purpose and Scope",
          value: sowEnrichData.data?.purpose_and_scope || "-",
        },
      ],
    },
    {
      icon: <SowAssemptionIco />,
      assumptions: [
        {
          title: "Assumptions",
          value: sowEnrichData.data?.assumptions || [],
        },
      ],
    },
  ];
  const buttonSupport = [
    {
      name: "Job",
      icon: <CandidateSupportIco />,
    },
    {
      name: "Support",
      icon: <SupportIco />,
    },
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];

  const handleChange = (event, newValue) => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      setSaveEditData((prev) => ({
        ...prev,
        open: true,
        prevData: newValue,
        view: false,
      }));
    } else {
      setValue(newValue);
      const index = newValue - 3;
      const resumeId = resumeTab[newValue - 3]?.id;

      const urlParams = new URLSearchParams(valueLocation);
      urlParams.delete("value");
      urlParams.append("value", newValue);
      urlParams.delete("match-id");
      if (newValue && parseInt(newValue) >= 2) {
        urlParams.append("match-id", resumeId);
      }
      const newUrl = `/judica/judica-view?${urlParams.toString()}`;
      navigate(newUrl);
      if (newValue && parseInt(newValue) >= 3) {
        fetchResumeData(resumeId, index);
      }
    }
  };

  const handleSaveCandidate = () => {
    setSaveEditData({
      open: false,
      prevData: "",
      leaveLoading: false,
      disabled: false,
      saveLoading: false,
      view: false,
    });
  };

  const handlebackGroundWarningClose = () => {
    setBackGroundprocess({
      open: false,
      disabled: false,
      openLoading: false,
      buttonLoading: false,
      hiringLoading: false,
      goldenLoading: false,
    });
  };

  const handlebackGroundWarning = () => {
    setBackGroundprocess((prev) => ({
      ...prev,
      buttonLoading: true,
    }));
    setTimeout(() => {
      handlebackGroundWarningClose();
    }, 1000);
  };

  const handleClick = () => {
    setSaveEditData((prev) => ({
      ...prev,
      open: true,
      prevData: "2",
      view: false,
    }));
  };
  const [pageTitle, setPageTitle] = React.useState(query.get("title") || "");

  const breadCrumbData = [
    {
      title: "Judica",
      navigate: `/judica`,
    },
    {
      title: pageTitle,
      active: true,
    },
  ];

  const fetchJobDataDetail = async (condition) => {
    if (jobId) {
      setTableLoader(true);
      setResumeLoader(true);
      setSowJudicaData((prev) => ({ ...prev, loading: true }));
      let params = {};
      if (
        localStorageData?.organization === "Demo" &&
        localStorageData?.role === "Demo" &&
        (condition || query.get("is_demo") === "true")
      ) {
        params = {
          is_demo: true,
        };
      }
      try {
        const res = await GetJobDataDetail(jobId, params);
        setJobData(res?.data);
        setResumeTab(res?.data?.resumes || []);
        setSowJudicaData({ data: res?.data, loading: false });
        setJobDropDown({
          data: res?.data.resources_required.find((item) => item.id === jobId),
        });
        setResumeScore(res?.data?.rescore_resumes || []);
        const queryValue = query?.get("value");
        const resumeData = res?.data?.resumes;

        if (queryValue >= "3" && resumeData.length !== 0) {
          const data = resumeData[queryValue - 3]?.id;
          const index = queryValue - 3;
          setValue(queryValue);
          await fetchResumeData(data, index, resumeData, "");
        } else if (queryValue <= "2") {
          setValue(queryValue || "1");
        }
        setTableLoader(false);
        setResumeLoader(false);
      } catch (error) {
        setTableLoader(false);
        setResumeLoader(false);
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.message,
        });
        setSowJudicaData((prev) => ({ ...prev, loading: false }));
      }
    } else {
    }
  };

  const fetchResumeData = async (resumeId, index, resumeObj, paramLabel) => {
    setResumeLoader(true);

    try {
      const data = await GET(getMatchedJdResumeData(resumeId), paramLabel);
      let arr = [...(resumeObj ? resumeObj : resumeTab)];
      let detailObj = {
        ...data?.data,
        candidate_name: data?.data?.resume_info?.candidate_name,
        name: (resumeObj ? resumeObj : resumeTab)?.[index]?.name,
        pay_rate: data?.data?.resume_info?.pay_rate,
        location: data?.data?.resume_info?.location,
        inferred_title: data?.data?.resume_info?.inferred_title,
        visa_info: data?.data?.resume_info?.visa_info,
        website: data?.data?.resume_info?.website,
        email: data?.data?.resume_info?.email,
        overall_score: data?.data?.quick_match_score?.overall_score,
        results: data?.data?.results || [],
        skill_calculation: data?.data?.skill_calculation,
        error_message: data?.data?.error_message,
        resume_id: data?.data?.resume_id,
        // file_name: data?.resume_file_name,
        spider_graph_results: data?.data?.spider_graph_results,
        file_name: data?.data?.resume_file_name,
        insights: data?.data?.insights,
        feedback: data?.data?.feedback,
        match_summary: data?.data?.match_summary,
        experience: data?.data?.experience,
        coversheet_added: data?.data?.coversheet_added,
        data: {
          personal_details: {
            candidate_name: data?.data?.resume_info?.candidate_name,
            inferred_title: data?.data?.resume_info?.inferred_title,
          },
        },
      };
      if (arr[index]) {
        arr[index] = {
          ...arr[index],
          details: detailObj,
        };
      }
      // else if (resumeObj) {
      //   arr.push({
      //     ...resumeObj,
      //     details: detailObj,
      //   });
      // }
      if (arr.length === 0) {
        setValue("0");
      }

      setResumeTab(arr);
      setMatchedData(arr[index]?.details);

      setResumeLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.response?.data?.message,
      });
      setResumeLoader(false);
    }
  };

  React.useEffect(() => {
    fetchJobDataDetail();
    // handleChatBotFetchData();
    dispatch(MinimizeIcon(false, true));
  }, [jobId]);

  //dame notes

  const handleCloseDownloadJdDialog = () => {
    setOpenDownloadJdDialog(false);
  };

  const handleDownloadJd = (row) => {
    if (row.id) {
      GETDOWNLOAD(DownloadJd(row.id), {
        params: { type: "match_resume" },
        responseType: "blob",
      })
        .then((response) => {
          const contentType = response.headers["content-type"];
          const extension =
            contentType === "application/pdf"
              ? "pdf"
              : contentType ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              ? "docx"
              : "doc";

          const fileName = `${row?.file_name}.${extension}`;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: contentType })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              const responseText = reader.result;
              try {
                const json = JSON.parse(responseText);
                const errorMessage =
                  json.error || "An unexpected error occurred.";
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message: errorMessage,
                });
              } catch (e) {
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message:
                    "An unexpected error occurred while parsing the error message.",
                });
              }
            };
            reader.readAsText(error.response.data);
          } else {
            setSnackbarState({
              open: true,
              severity: "error",
              message: "An unexpected error occurred.",
            });
          }
        });
    } else {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "JD was not parsed successfully. Unable to download.",
      });
    }
  };

  const fetchJdFileList = async () => {
    setJdFileListLoader(true);
    if (jobId) {
      try {
        const res = await GET(getJdFileList(jobId));
        if (res?.success) {
          setJdFileList(res?.data);
          setJdFileListLoader(false);
        }
      } catch (error) {
        setJdFileListLoader(false);
      }
    }
  };

  const handleDownloadJdOpen = () => {
    setOpenDownloadJdDialog(true);
    fetchJdFileList();
  };
  //add more candidate functionality

  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);
    const existing = JSON.parse(localStorage.getItem("job_candidate")) || {};
    let checkData = {
      file: mergedFiles.map((f) => ({
        ...f,
        progress: 0,
        buffer: 0,
        visible: false,
        delete: false,
        file: {
          name: f.file.name,
          size: f.file.size,
          type: f.file.type,
          lastModified: f.file.lastModified,
          ...f.file,
        },
      })),
    };
    const updated = {
      ...existing,
      [jobId]: {
        ...existing[jobId],
        file: checkData.file,
        status: "Inprogress",
      },
    };
    localStorage.setItem("job_candidate", JSON.stringify(updated));
    dispatch(
      JobCandidateResume({
        id: jobId,
        file: updated[jobId].file,
        status: "Inprogress",
      })
    );

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };

  const handleAddMoreCandidateDialogClose = () => {
    setAddMoreCandidateDialogOpen(false);
    setAddMoreCandidateFiles([]);
  };

  const handleAddMoreCandidateOpen = async ({ condition }) => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      handleClick();
    } else {
      setBackGroundprocess((prev) => ({
        ...prev,
        disabled: true,
        openLoading: condition === "CANDIDATE" ? true : false,
        hiringLoading: condition === "HIRING MANAGER" ? true : false,
        goldenLoading: condition === "GOLDEN RECORD" ? true : false,
      }));
      try {
        const data = await checkBackGroundProcess(jobId);
        if (!data?.background_process_status) {
          setAddMoreCandidateDialogOpen(true);
        }
        setBackGroundprocess((prev) => ({
          ...prev,
          disabled: false,
          open: data?.background_process_status,
          openLoading: false,
          hiringLoading: false,
          goldenLoading: false,
          type: condition,
        }));
      } catch (error) {
        setBackGroundprocess((prev) => ({
          ...prev,
          disabled: false,
          openLoading: false,
          hiringLoading: false,
          goldenLoading: false,
        }));
        setSnackbarState({
          open: true,
          message: error.message,
          severity: "error",
        });
      }
    }
  };

  const handleAddMoreCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const handleAddMoreCandidateDeleteFile = (index) => {
    setAddMoreCandidateFiles((prevFiles) =>
      prevFiles.filter((_, i) => i !== index)
    );
  };

  const handleAddMoreCandidateDragOver = (event) => {
    event.preventDefault();
    setIsAddMoreCandidateDragging(true);
  };

  const handleAddMoreCandidateDragLeave = () => {
    setIsAddMoreCandidateDragging(false);
  };

  const handleAddMoreCandidateDrop = (event) => {
    event.preventDefault();
    setIsLoading(false);
    setIsAddMoreCandidateDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const processJsonResponse = (
    jsonResponse,
    getName,
    setCandidateFiles,
    getAddMore
  ) => {
    const { success, data, message } = jsonResponse;
    if (success && data?.percent !== undefined) {
      const storedData = JSON.parse(localStorage.getItem("job_candidate"));
      const getData = storedData?.[jobId]?.file?.map((f) =>
        f.name === data.current_resume
          ? {
              ...f,
              progress: data.percent,
              buffer: data.buffer || data.percent,
              visible: false,
              delete: false,
              progress_message: data.progress_message,
            }
          : f
      );
      const updated = {
        ...storedData,
        [jobId]: {
          ...storedData[jobId],
          file: getData,
          status: "Inprogress",
        },
      };

      localStorage.setItem("job_candidate", JSON.stringify(updated));

      dispatch(
        JobCandidateResume({
          id: jobId,
          file: getData,
          status: "Inprogress",
        })
      );

      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.name === data.current_resume
            ? {
                ...f,
                progress: data.percent,
                buffer: data.buffer || data.percent,
                visible: false,
                delete: false,
                progress_message: data.progress_message,
              }
            : f
        )
      );
    } else if (getAddMore === "Add-more-Candidate" && data?.length !== 0) {
      setAddMoreCandidateDialogOpen(false);
      setAddMoreCandidateFiles([]);
      if (Array.isArray(data) && data.length > 0 && data[0]?.jd_info) {
        let responseId = data[0]?.id;
        let arr = [...resumeTab];
        let resumeObj = {
          id: responseId,
          name: data[0]?.resume_info?.candidate_name
            ? data[0]?.resume_info?.candidate_name
            : "",
          score: data[0]?.quick_match_score?.overall_score
            ? data[0]?.quick_match_score?.overall_score
            : data[0]?.score,
          file_name: data[0]?.resume_file_name,
        };
        arr.push(resumeObj);
        setResumeTab(arr);
        fetchSummaryDetails();
        fetchJobDataDetail();

        const storedData = JSON.parse(localStorage.getItem("job_candidate"));
        const updated = {
          ...storedData,
          [jobId]: {
            ...storedData[jobId],
            file: [],
            status: "success",
          },
        };
        localStorage.setItem("job_candidate", JSON.stringify(updated));
        dispatch(
          JobCandidateResume({
            id: jobId,
            file: [],
            status: "success",
          })
        );
      }
    } else if (!success) {
      const storedData = JSON.parse(localStorage.getItem("job_candidate"));
      const getData = storedData?.[jobId]?.file?.map((f) =>
        f.name === data.current_resume
          ? {
              ...f,
              visible: true,
              message: message,
              delete: true,
            }
          : { ...f, delete: true }
      );
      const updated = {
        ...storedData,
        [jobId]: {
          ...storedData[jobId],
          file: getData,
          status: "fail",
        },
      };
      localStorage.setItem("job_candidate", JSON.stringify(updated));
      dispatch(
        JobCandidateResume({
          id: jobId,
          file: getData,
          status: "fail",
        })
      );

      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.name === data.current_resume || data.length === 0
            ? {
                ...f,
                visible: true,
                delete: true,
                message: message,
              }
            : { ...f, delete: true }
        )
      );
    }
  };

  const fetchSummaryDetails = async (condition) => {
    try {
      let params = {};
      if (
        localStorageData?.organization === "Demo" &&
        localStorageData?.role === "Demo" &&
        (condition || query.get("is_demo") === "true")
      ) {
        params = {
          is_demo: true,
        };
      }
      setTableLoader(true);
      await dispatch(JobSummary(jobId, params));
      setTableLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error?.data?.message || error?.message,
        severity: "error",
      });
      setTableLoader(false);
    }
  };

  const uploadFile = async (getName, setCandidateFiles, getAddMore) => {
    setIsLoading(true);

    setCandidateFiles((prevFiles) =>
      prevFiles.map((f) => ({
        ...f,
        delete: false,
      }))
    );

    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    ) {
      try {
        const urlParams = new URLSearchParams(valueLocation);
        urlParams.delete("value");
        urlParams.append("is_demo", true);
        const newUrl = `/judica/judica-view?${urlParams.toString()}`;
        navigate(newUrl);

        const startProgressUpdate = () => {
          const intervalStep = async () => {
            let allComplete = false;

            setCandidateFiles((prevFiles) => {
              const updatedFiles = prevFiles.map((f) => {
                const updatedProgress = f.progress + 10;
                const isComplete = updatedProgress >= 100;

                if (isComplete) {
                  allComplete = true;
                  return { ...f, progress: 100, buffer: 100 };
                }

                return {
                  ...f,
                  progress: updatedProgress,
                  buffer: updatedProgress,
                  visible: false,
                  delete: false,
                };
              });

              return updatedFiles;
            });

            if (allComplete) {
              setAddMoreCandidateDialogOpen(false);
              setAddMoreCandidateFiles([]);
              setIsLoading(true);

              await fetchSummaryDetails(true);
              await fetchJobDataDetail(true);

              setIsLoading(false);
              setSnackbarState({
                open: true,
                message: "Update Successfully",
                severity: "success",
              });
            } else {
              setTimeout(intervalStep, 300);
            }
          };

          intervalStep();
        };
        startProgressUpdate();
      } catch (error) {
        setSnackbarState({
          open: true,
          message: "Error parsing JSON",
          severity: "error",
        });
      }
    } else {
      const formData = new FormData();
      if (getAddMore === "Add-more-Candidate") {
        addMoreCandidateFiles.forEach((fileObj, index) => {
          formData.append("resume_file", fileObj.file);
        });
        formData.append("type", backGroundprocess.type);
        formData.append("id", jobId);

        try {
          const response = await UploadJob(formData, getName, "Active");
          const reader = response.body.getReader();
          const decoder = new TextDecoder("utf-8");
          let buffer = "";

          while (true) {
            const { value, done } = await reader.read();
            if (done) break;
            const chunk = decoder.decode(value, { stream: true });
            buffer += chunk;
            let boundaryIndex;
            while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
              const jsonString = buffer.slice(0, boundaryIndex + 1);
              buffer = buffer.slice(boundaryIndex + 1);
              const jsonResponse = JSON.parse(jsonString);
              try {
                await processJsonResponse(
                  jsonResponse,
                  getName,
                  setCandidateFiles,
                  getAddMore
                );
              } catch (e) {
                const storedData = JSON.parse(
                  localStorage.getItem("job_candidate")
                );
                const getData = storedData?.[jobId]?.file?.map((f) =>
                  f.name === jsonResponse.data.current_resume
                    ? {
                        ...f,
                        visible: true,
                        delete: true,
                        message: e.message,
                      }
                    : { ...f }
                );
                const updated = {
                  ...storedData,
                  [jobId]: {
                    ...storedData[jobId],
                    file: getData,
                    status: "fail",
                  },
                };
                localStorage.setItem("job_candidate", JSON.stringify(updated));
                dispatch(
                  JobCandidateResume({
                    id: jobId,
                    file: getData,
                    status: "fail",
                  })
                );

                setSnackbarState({
                  open: true,
                  message: "Error parsing JSON",
                  severity: "error",
                });
                setCandidateFiles((prevFiles) =>
                  prevFiles.map((f) =>
                    f.name === jsonResponse.data.current_resume
                      ? {
                          ...f,
                          visible: true,
                          delete: true,
                        }
                      : { ...f, delete: true }
                  )
                );
              }
            }
          }

          if (buffer) {
            const jsonResponse = JSON.parse(buffer);
            try {
              await processJsonResponse(
                jsonResponse,
                getName,
                setCandidateFiles,
                getAddMore
              );
            } catch (e) {
              const storedData = JSON.parse(
                localStorage.getItem("job_candidate")
              );
              const getData = storedData?.[jobId]?.file?.map((f) =>
                f.name === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      delete: true,
                      message: jsonResponse.message,
                    }
                  : { ...f, delete: true }
              );
              const updated = {
                ...storedData,
                [jobId]: {
                  ...storedData[jobId],
                  file: getData,
                  status: "fail",
                },
              };
              localStorage.setItem("job_candidate", JSON.stringify(updated));
              dispatch(
                JobCandidateResume({
                  id: jobId,
                  file: getData,
                  status: "fail",
                })
              );

              setSnackbarState({
                open: true,
                message: "Error parsing final JSON chunk",
                severity: "error",
              });
              setCandidateFiles((prevFiles) =>
                prevFiles.map((f) =>
                  f.name === jsonResponse.data.current_resume
                    ? {
                        ...f,
                        visible: true,
                        delete: true,
                      }
                    : { ...f, delete: true }
                )
              );
            }
          }
          setIsLoading(false);
        } catch (error) {
          const storedData = JSON.parse(localStorage.getItem("job_candidate"));
          const getData = storedData?.[jobId]?.file?.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: '"Error during the request',
          }));
          const updated = {
            ...storedData,
            [jobId]: {
              ...storedData[jobId],
              file: getData,
              status: "fail",
            },
          };
          localStorage.setItem("job_candidate", JSON.stringify(updated));
          dispatch(
            JobCandidateResume({
              id: jobId,
              file: getData,
              status: "fail",
            })
          );

          setSnackbarState({
            open: true,
            message: "Error during the request",
            severity: "error",
          });
          setCandidateFiles((prevFiles) =>
            prevFiles.map((f) => ({
              ...f,
              visible: true,
              delete: true,
              message: "Error during the request",
            }))
          );

          setIsLoading(false);
        }
      }
    }
  };

  const handleAddMoreCandidateClick = async () => {
    if (addMoreCandidateFiles.length === 0) {
      setSnackbarState({
        open: true,
        message: "Upload the Files",
        severity: "error",
      });
    } else {
      uploadFile(
        "Upload-Candidate",
        setAddMoreCandidateFiles,
        "Add-more-Candidate"
      );
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleLeave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      leaveLoading: true,
    }));
    await dispatch(
      JobJobFormikData(JobJobEditData.formikData, JobJobEditData.formikData)
    );
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        leaveLoading: false,
        open: false,
        view: prev.prevData === "2" ? true : false,
      }));

      callBack(saveEditData.prevData);
    } catch (error) {}
  };

  const handleSave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      saveLoading: true,
    }));

    const values = JobJobEditData.jobData;
    const result = (valueData) => {
      if (!valueData) return [];

      const processedData = valueData.reduce((acc, { name, content }) => {
        const existing = acc.find((item) => item.name === name);
        if (existing) {
          existing.content.push(content);
        } else {
          acc.push({ name, content: [content] });
        }
        return acc;
      }, []);

      const extracted = processedData.find((item) => item.name === "extracted");
      const inferred = processedData.find((item) => item.name === "inferred");
      const userAdded = processedData.find(
        (item) => item.name === "user_added"
      );

      const resultData = [];
      if (!extracted) {
        resultData.push({ name: "extracted", content: [] });
      } else {
        resultData.push(extracted);
      }
      if (!inferred) {
        resultData.push({ name: "inferred", content: [] });
      } else {
        resultData.push(inferred);
      }
      const otherData = processedData.filter(
        (item) =>
          item.name !== "extracted" &&
          item.name !== "inferred" &&
          item.name !== "user_added"
      );
      resultData.push(...otherData);
      if (!userAdded) {
        resultData.push({ name: "user_added", content: [] });
      } else {
        resultData.push(userAdded);
      }
      return resultData;
    };

    const data = {
      ...JobJobEditData,
      ...values,
      employer_targets: result(values.employer_targets),
      certificates: result(values.certificates),
      languages: result(values.languages),
      shift: result(values.shift),
      visa_status: rebuildSourceFromFinalData(values.visa_status),
      location_targets: result(values.location_targets),
      high_priority: values.skillData.high_priority,
      low_priority: values.skillData.low_priority,
      medium_priority: values.skillData.medium_priority,
      recommended: values.skillData.recommended,
      // industry: jobValue.industry.map((item) => item.name),
      industry: rebuildSourceFromFinalData(values.industry),
      required_years_for_industry: {
        months: JobJobEditData.required_years_for_industry?.months,
        years: parseInt(values.required_years_for_industry),
      },
    };

    try {
      dispatch(JobJobFormikData(values, values));
      const jobEdit = await JobJobSubmit(values.id, data);
      setSnackbarState({
        open: true,
        severity: "success",
        message: jobEdit.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        open: false,
        view: prev.prevData === "2" ? true : false,
      }));
      callBack(saveEditData.prevData);
    } catch (error) {
      dispatch(JobJobFormikData(JobJobEditData.jobData, values));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        view: false,
      }));
    }
  };

  const callBack = (newValue) => {
    setValue(newValue);
    const index = newValue - 3;
    const resumeId = resumeTab[newValue - 3]?.id;
    const urlParams = new URLSearchParams(valueLocation);
    urlParams.delete("value");
    urlParams.append("value", newValue);
    const newUrl = `/judica/judica-view?${urlParams.toString()}`;
    navigate(newUrl);
    if (newValue && parseInt(newValue) >= 3) {
      fetchResumeData(resumeId, index);
    }
  };
  const fetchSowRequirement = async (id) => {
    setIsLoading(true);
    setSowEnrichData((prev) => ({ ...prev, loading: true }));
    try {
      let data = await SowEnrichGetCall(id);
      setSowEnrichData({ data: data?.data, loading: false });
      setIsLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
      setIsLoading(false);
      setSowEnrichData((prev) => ({ ...prev, loading: false }));
    }
  };

  React.useEffect(() => {
    const functionCall = async () => {
      if (chatBotData.selectedValue === "Support") {
        handleSupportCall();
      } else {
        await handleChatBotFetchData();
        if (questionMarkItemRef.current) {
          handleButtonClickByLabel(questionMarkItemRef.current);
        }
      }
    };
    functionCall();

    if (parseInt(value) >= 2) {
      setChatBotData((prev) => ({
        ...prev,
        bubbleCondition: true,
      }));
    } else {
      setChatBotData((prev) => ({
        ...prev,
        bubbleCondition: false,
      }));
    }
    if (parseInt(value) === 0) {
      fetchSowRequirement(sowJudicaData.data?.ignite_id);
    }
  }, [value]);

  const Footer = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        color="#344054"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        border={"#D0D5DD"}
        onClick={handleLeave}
        disabled={saveEditData.disabled}
        loading={saveEditData.leaveLoading}
      />
      <CommonButton
        value={"Save"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={saveEditData.disabled}
        loading={saveEditData.saveLoading}
        onClick={handleSave}
      />
    </CommonGrid2>
  );

  const BackGroundFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"OK"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        onClick={handlebackGroundWarning}
        disabled={backGroundprocess.disabled}
        loading={backGroundprocess.buttonLoading}
      />
    </CommonGrid2>
  );

  const handleChatBotFetchData = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [],
    }));
    let params = {
      match_id: resumeId,
    };
    try {
      const data = await ChatBotGetCall(jobId, params);
      const messages = [];
      data?.data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [
          {
            sender: "bot",
            text: "Hi, I am Hailey. How can I assist you today?",
          },
          ,
          ...messages,
        ],
        bubble: parseInt(value) == 2 ? data?.data?.bubble_questions.filter(item => item.module_name === "Job") || [] : data?.data?.bubble_questions.filter(item => item.module_name === "Match") || [],
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;

    let payload;
    if (chatBotData.selectedValue === "Job") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "match_data",
          job_data_id: jobId,
        },
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }
    setMinimizeScreen(true);
    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Job") {
        data = await dispatch(ChatBotCall(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
    }
  };

  const handleChatBotChange = (event) => {
    if (event.type === "keydown") {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        handleSendMessage();
      }
      return;
    }

    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleButtonClickByLabel = async (item) => {
    const senderResponse = {
      sender: "user",
      text: item.question,
    };
    setMinimizeScreen(true);
    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, senderResponse],
      loader: true,
    }));
    setChatBotData((prev) => ({
      ...prev,
      arrow: true,
    }));

    let payload = {
      query: item.prompt,
      filter_criteria: {
        type: "match_data",
        job_data_id: jobId,
      },
      match_id: resumeId,
    };

    try {
      const data = await dispatch(ChatBotCall(payload));
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
    }
  };

  const handleQuestionMarkClick = (item) => {
    questionMarkItemRef.current = item;
    setOpen((prev) => {
      dispatch(MinimizeIcon(false, true));
      return true;
    });
    functionCall();
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedTabs = [...resumeTab];
    const [movedItem] = reorderedTabs.splice(result.source.index, 1);
    reorderedTabs.splice(result.destination.index, 0, movedItem);
    setResumeTab(reorderedTabs);
  };

  const handleToggleDrawer = () => {
    if (chatBotData.selectedValue === "Support") {
      handleChatBotFetchData();
    }
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Job",
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev;
      dispatch(MinimizeIcon(prev, newState));
      return newState;
    });
  };

  const functionCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue:
        prev.selectedValue === "Report Bug" ? "Job" : prev.selectedValue,
    }));

    if (chatBotData.selectedValue === "Support") {
      handleSupportCall();
    } else {
      await handleChatBotFetchData();
      if (questionMarkItemRef.current) {
        handleButtonClickByLabel(questionMarkItemRef.current);
      }
    }
  };

  React.useEffect(() => {
    functionCall();
  }, []);

  const handleOverwriteClick = () => {
    setMinimizeScreen((prev) => !prev);
  };

  const handleSelectJob = (e) => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      setSaveEditData((prev) => ({
        ...prev,
        open: true,
        prevData: 2,
        view: false,
      }));
    } else {
      const selectedJob = e.target.value;

      setJobDropDown({ data: e.target.value });
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("id", selectedJob.id);
      searchParams.set("title", selectedJob.job_title);
      searchParams.set("status", selectedJob.status);

      navigate(`${location.pathname}?${searchParams.toString()}`);
    }
  };

  const CustomMenuItem = (item, index) => (
    <MenuItem value={item} key={index}>
      {item?.job_title}
    </MenuItem>
  );

  const CustomMenuItemStatus = (item, index) => (
    <MenuItem value={item} key={index}>
      {item?.status}
    </MenuItem>
  );

  React.useEffect(() => {
    setTimeout(() => {
      if (gridRef.current) {
        const height = gridRef.current.getBoundingClientRect().height;
        setGridHeight(height);
      }
    }, 400);
  }, [open, minimizeScreen, location, resumeTab, value, ref]);

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [],
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);

      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [
          {
            sender: "bot",
            text: "Hi, I am Hailey. How can I assist you today?",
          },
          ,
          ...messages,
        ],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch({ type: LAYOUT.anyChatOpen, data: false });
      dispatch(MinimizeIcon(true, false));
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    } else if (name === "Job") {
      handleChatBotFetchData();
    }
  };

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
    >
      <TabContext value={value}>
        <CommonGrid2
          width={
            open
              ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "350px"})`
              : "100%"
          }
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          background="#fff"
          borderRadius={"10px"}
          height={"fit-content"}
          padding={"1rem"}
          margin={"1.35rem"}
          position={"relative"}
          sx={{
            transition: theme.transitions.create(["width"], {
              duration: theme.transitions.duration.short,
              easing: theme.transitions.easing.easeInOut,
            }),
          }}
          ref={ref}
        >
          <Breadcrumbs breadCrumbData={breadCrumbData} />

          <Slide
            direction="left"
            in={value === "0"}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value="0" padding="1rem 0px 0px">
              <SowSummary
                sowSummary_clientInformation={sowSummary_clientInformation}
                isLoading={isLoading}
              />
            </TabPanelView>
          </Slide>

          <Slide
            direction="up"
            in={value === "1"}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value="1" padding="1rem 0px 0px">
              <JobsSummary fetchData={fetchJobDataDetail} />
            </TabPanelView>
          </Slide>

          <Slide
            direction="up"
            in={value === "2"}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value="2" padding="1rem 0px 0px">
              <JemPlus
                jobData={jobData}
                jobId={jobId}
                handleDownloadJdOpen={handleDownloadJdOpen}
                fetchData={fetchJobDataDetail}
                handleClick={handleClick}
                saveEditData={saveEditData}
                resumeTab={resumeScore}
                bounds={bounds}
                onTitleUpdate={(newTitle) => {  
                  setPageTitle(newTitle);
                  const urlParams = new URLSearchParams(window.location.search);
                  urlParams.set("title", newTitle);
                  window.history.replaceState(null, "", `/jobs/jobs-view?${urlParams.toString()}`);
                }}
              />
            </TabPanelView>
          </Slide>
          {resumeTab.map((elt, index) => (
            <Slide
              direction="up"
              in={value === (index + tabData.length).toString()}
              timeout={500}
              mountOnEnter
              unmountOnExit
            >
              <TabPanelView
                value={(index + tabData.length).toString()}
                padding="2rem 0px 0px"
                key={index + tabData.length}
              >
                <JobsCandidate
                  dummy_value={1}
                  matchedData={matchedData}
                  resumeId={resumeId}
                  resumeLoader={resumeLoader}
                  filteredResumeTab={filteredResumeTab}
                  fetchResumeData={fetchResumeData}
                  fetchData={fetchJobDataDetail}
                  handleQuestionMarkClick={handleQuestionMarkClick}
                  chatBotData={chatBotData}
                  iconVisible={
                    chatBotData.selectedValue === "Support"
                      ? false
                      : !chatBotData.loader && !chatBotData.pageLoader
                  }
                  jobData={jobData}
                />
              </TabPanelView>
            </Slide>
          ))}
        </CommonGrid2>

        <CommonGrid2
          sx={{
            transition: theme.transitions.create(["width"], {
              duration: theme.transitions.duration.short,
              easing: theme.transitions.easing.easeInOut,
            }),
          }}
          width={open ? (chatBotData.expandDrawer ? "450px" : "350px") : "0px"}
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          background="#fff"
          top={"0px"}
          position={"sticky"}
          right={"0.5rem"}
          height={"100%"}
          overflowY={"auto"}
          scrollStyle
          scrollBar="5px"
        >
          {open && (
            <>
              <CommonGrid2
                item
                ref={gridRef}
                padding={"0.5rem 1rem 0px"}
                // height={
                //   !minimizeScreen
                //     ? resumeTab.length >= 3
                //       ? "460px"
                //       : "auto"
                //     : "auto"
                // }
                overflowY={"scroll"}
                scrollStyle
                displayBar="none"
              >
                <CommonGrid2
                  display={"flex"}
                  flexWrap={"wrap"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  padding={"0.5rem 0px 0.8rem"}
                >
                  <CommonGrid2 display={"flex"} gap={"4px"}>
                    <HaileyChatBotIco />
                    <Typography variant="h5" color="#101828">
                      Hailey
                    </Typography>
                  </CommonGrid2>
                  <CommonGrid2
                    display={"flex"}
                    gap={"5px"}
                    alignItems={"center"}
                  >
                    <CommonTippy
                      content={chatBotData.expandDrawer ? "Collapse" : "Expand"}
                      placement="top"
                      color={"#7F56D9"}
                      fontSize="11px"
                    >
                      <HaileyButton onClick={handleExpandDrawer} padding="0px">
                        {chatBotData.expandDrawer ? (
                          <HaileyCollapseIco />
                        ) : (
                          <HaileyExpandIco />
                        )}
                      </HaileyButton>
                    </CommonTippy>
                    <CommonTippy
                      content="Close"
                      placement="top"
                      color={"#7F56D9"}
                      fontSize="11px"
                    >
                      <HaileyButton onClick={handleToggleDrawer} padding="0px">
                        <XCloseIco size={"22px"} />
                      </HaileyButton>
                    </CommonTippy>
                  </CommonGrid2>
                </CommonGrid2>
                <CommonGrid2
                  size="12"
                  marginTop={"1rem"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  gap={"2rem"}
                >
                  <Typography variant="h4" fontWeight={700}>
                    {query.get("title")}
                  </Typography>
                  <IconButton>
                    <HeartIco />
                  </IconButton>
                </CommonGrid2>

                <CommonGrid2 marginTop={"10px"}>
                  <JudicaTabViewSection
                    orientation="vertical"
                    onChange={handleChange}
                  >
                    <Tab
                      label={
                        <CommonGrid2
                          display={"flex"}
                          alignItems={"center"}
                          gap="10px"
                        >
                          {tabData[0].icon}
                          {tabData[0].name}
                        </CommonGrid2>
                      }
                      value={"0"}
                    />
                  </JudicaTabViewSection>
                </CommonGrid2>

                <CommonGrid2
                  display={"flex"}
                  size="12"
                  container
                  gap={"10px"}
                  margin="1rem 0px 1.2rem 0px"
                >
                  <CommonGrid2
                    size={7.5}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"10px"}
                  >
                    <Typography variant="h5">Jobs</Typography>
                    {sowJudicaData.loading ? (
                      <HandleSkeletion
                        width="100%"
                        height="35px"
                        marginRight={"1rem"}
                        transform="scale(1)"
                      />
                    ) : (
                      <DropDownSelect
                        marginTop="0px"
                        sizeMedium="-8px"
                        padding={"8px"}
                        valueChange={true}
                        CustomMenuItem={CustomMenuItem}
                        title={"Select jobs"}
                        handleChange={handleSelectJob}
                        handleRenderValue={(selected) => {
                          return selected.job_title;
                        }}
                        data={sowJudicaData.data?.resources_required}
                        value={jobDropdown.data}
                        removeAnimation={true}
                        customStyle={{
                          "& .MuiInputLabel-shrink": {
                            fontSize: "15px",
                          },
                          "& label": {
                            fontSize: "14px",
                          },
                        }}
                      />
                    )}
                  </CommonGrid2>
                  <CommonGrid2
                    size={4}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"10px"}
                  >
                    <Typography variant="h5">Status</Typography>
                    {sowJudicaData.loading ? (
                      <HandleSkeletion
                        width="100%"
                        height="35px"
                        marginRight={"1rem"}
                        transform="scale(1)"
                      />
                    ) : (
                      <DropDownSelect
                        marginTop="0px"
                        removeAnimation={true}
                        fullWidth={false}
                        title={"Select Status"}
                        handleRenderValue={(selected) => {
                          return selected.status;
                        }}
                        valueChange={true}
                        CustomMenuItem={CustomMenuItemStatus}
                        data={sowJudicaData.data?.resources_required}
                        value={jobDropdown.data}
                        disabled={true}
                        customStyle={{
                          "& .MuiSelect-select": {
                            padding: "8px 32px 8px 10px !important",
                            borderRadius: "6px",
                          },
                          "& fieldset": {
                            borderWidth: "1px",
                          },
                          "& .MuiSelect-icon": {
                            right: "0rem",
                          },
                          "& .MuiInputLabel-shrink": {
                            fontSize: "15px",
                          },
                          "& label": {
                            fontSize: "14px",
                          },
                        }}
                      />
                    )}
                  </CommonGrid2>
                </CommonGrid2>

                <Collapse in={!minimizeScreen} timeout={400} unmountOnExit>
                  <CommonGrid2
                    size="12"
                    // margin={"1rem 0px"}
                    gap={"3rem"}
                    alignItems={"center"}
                  >
                    <Typography variant="h5">Overall</Typography>
                    <CommonGrid2
                      container
                      spacing={2}
                      alignItems="center"
                      marginTop={1}
                    >
                      <JudicaTabViewSection
                        orientation="vertical"
                        onChange={handleChange}
                      >
                        {tabData.map((item, index) => {
                          if (index > 0)
                            return (
                              <Tab
                                label={
                                  <CommonGrid2
                                    display={"flex"}
                                    alignItems={"center"}
                                    gap="10px"
                                  >
                                    {item.icon}
                                    {item.name}
                                  </CommonGrid2>
                                }
                                value={index.toString()}
                              />
                            );
                        })}
                      </JudicaTabViewSection>
                    </CommonGrid2>

                    <CommonGrid2
                      size="12"
                      margin={"1rem 0px 0px"}
                      display={"flex"}
                      gap={"1rem"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Typography
                        variant="h5"
                        marginBottom={"10px"}
                        color="#344054"
                      >
                        Candidates
                      </Typography>
                      <CommonTippy
                        content="Add Candidates"
                        placement="top"
                        color={"#7F56D9"}
                        fontSize="12px"
                        bottom={"5px"}
                      >
                        <CustomDiv>
                          <CommonButton
                            value={"Add"}
                            variant="text"
                            startIcon={
                              backGroundprocess.openLoading ? (
                                ""
                              ) : (
                                <AddIcon
                                  sx={{
                                    stroke: "currentColor",
                                  }}
                                />
                              )
                            }
                            gap="0px"
                            padding={"5px 15px"}
                            fontWeight={600}
                            borderRadius={"5px"}
                            disabled={backGroundprocess.openLoading}
                            loading={backGroundprocess.openLoading}
                            onClick={() =>
                              handleAddMoreCandidateOpen({
                                condition: "CANDIDATE",
                              })
                            }
                            customStyle={{
                              "&.Mui-disabled": {
                                opacity: "0.8 !important",
                                gap: "10px !important",
                              },
                            }}
                          />
                        </CustomDiv>
                      </CommonTippy>
                    </CommonGrid2>

                    <GlobalStyles
                      styles={{
                        "[data-rbd-placeholder-context-id]": {
                          background: "transparent !important",
                          border: "none !important",
                          margin: 0,
                          padding: 0,
                        },
                      }}
                    />

                    <DragDropContext onDragEnd={onDragEnd}>
                      <Droppable
                        droppableId="droppable-tabs"
                        direction="vertical"
                      >
                        {(provided) => (
                          <JudicaCandidateTabViewSection
                            orientation="vertical"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            overflowY="auto !important"
                            scrollStyle={true}
                            scrollBar="5px"
                            scrollBarRadius="0px"
                            style={{ marginBottom: "0.8rem" }}
                            height={
                              value !== "0"
                                ? "auto"
                                : resumeTab.length >= 3
                                ? "148px"
                                : `${resumeTab.length * 49}px`
                            }
                          >
                            {resumeTab?.map((elt, index) => {
                              return tableLoader ? (
                                <HandleSkeletion
                                  width="100%"
                                  height="45px"
                                  marginRight={"1rem"}
                                />
                              ) : (
                                <Draggable
                                  key={elt.id}
                                  draggableId={elt.id.toString()}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <Tab
                                      ref={provided.innerRef}
                                      {...provided.dragHandleProps}
                                      {...provided.draggableProps}
                                      onChange={handleChange}
                                      className={
                                        (index + tabData.length).toString() ===
                                        value
                                          ? "Mui-selected"
                                          : ""
                                      }
                                      label={
                                        <CommonGrid2
                                          display={"flex"}
                                          gap={"5px"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}
                                          width={"100%"}
                                        >
                                          <CommonGrid2
                                            display={"flex"}
                                            gap={"7px"}
                                            alignItems={"center"}
                                          >
                                            <CustomDiv
                                              style={{ cursor: "grab" }}
                                            >
                                              <SkillDrag />
                                            </CustomDiv>

                                            {elt?.name
                                              ? elt?.name
                                              : elt?.file_name}
                                          </CommonGrid2>
                                          <CustomDiv
                                            display="flex"
                                            alignItems="center"
                                            fontSize="12px"
                                            background={
                                              elt?.score > 70
                                                ? "#ECFDF3"
                                                : "#F9FAFB"
                                            }
                                            border={
                                              elt?.score > 70
                                                ? "1px solid #AAEFC6"
                                                : "1px solid #EAECF0"
                                            }
                                            color={
                                              elt?.score > 70
                                                ? "#067647"
                                                : "#344054"
                                            }
                                            borderRadius="50px"
                                            padding="4px 10px"
                                          >
                                            {elt?.score}%
                                          </CustomDiv>
                                        </CommonGrid2>
                                      }
                                      value={(
                                        index + tabData.length
                                      ).toString()}
                                      key={index + tabData.length}
                                      sx={{
                                        textTransform: "none",
                                        "&.Mui-selected": {
                                          color: "black",
                                          fontWeight: "bold",
                                        },
                                        ...(snapshot.isDragging && {
                                          background: "#ebebeb",
                                        }),
                                      }}
                                    />
                                  )}
                                </Draggable>
                              );
                            })}

                            {provided.placeholder}
                          </JudicaCandidateTabViewSection>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </CommonGrid2>
                </Collapse>
              </CommonGrid2>
              {value !== "0" && (
                <CommonGrid2
                  size="12"
                  height={`calc(100% - ${gridHeight + 28}px)`}
                  boxShadow={
                    minimizeScreen ? "0px -4px 10px rgba(0, 0, 0, 0.1)" : "none"
                  }
                  transition={"box-shadow 0.3s ease-in-out"}
                >
                  <Divider />
                  <CommonButton
                    value={minimizeScreen ? "Minimize" : "Expand"}
                    variant="outlined"
                    color="#344054"
                    padding={"0px 1rem"}
                    background={"#fff"}
                    width="max-content"
                    fontWeight={"600"}
                    fontSize={"13px"}
                    gap="0px"
                    borderRadius={"50px"}
                    border={"#D0D5DD"}
                    startIcon={
                      minimizeScreen ? (
                        <KeyboardArrowDownIcon />
                      ) : (
                        <KeyboardArrowUpIcon />
                      )
                    }
                    customStyle={{
                      display: "flex",
                      position: "relative",
                      top: "-0.8rem",
                      margin: "auto",
                      "& .MuiButton-icon": {
                        marginRight: "5px",
                      },
                    }}
                    onClick={handleOverwriteClick}
                  />
                  <CommonGrid2
                    padding={"0 1rem 1rem"}
                    height={"100%"}
                    justifyContent={"space-between"}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <SideBarChatBot
                      handleToggleDrawer={handleToggleDrawer}
                      jobId={jobId}
                      height={minimizeScreen}
                      chatBotData={chatBotData}
                      // handleChatBotFetchData={handleChatBotFetchData}
                      handleSendMessage={handleSendMessage}
                      handleChatBotChange={handleChatBotChange}
                      isBottomVisible={isBottomVisible}
                      setIsBottomVisible={setIsBottomVisible}
                      handleUpArrow={handleUpArrow}
                      handleButtonClickByLabel={handleButtonClickByLabel}
                      userName={storageData?.username}
                      buttonSupport={buttonSupport}
                      handleButtonSupport={handleButtonSupport}
                      minimizeButton={false}
                    />
                  </CommonGrid2>
                </CommonGrid2>
              )}
            </>
          )}
        </CommonGrid2>
      </TabContext>

      {/* Download JD Dailog */}
      <DownloadJD
        openDownloadJdDialog={openDownloadJdDialog}
        handleCloseDownloadJdDialog={handleCloseDownloadJdDialog}
        jdFileList={jdFileList}
        handleDownloadJd={handleDownloadJd}
        jdFileListLoader={jdFileListLoader}
      />
      {/* Add Candidate Resume */}
      <AddMoreCandidate
        addMoreCandidateDialogOpen={addMoreCandidateDialogOpen}
        handleAddMoreCandidateDialogClose={handleAddMoreCandidateDialogClose}
        handleAddMoreCandidateDragOver={handleAddMoreCandidateDragOver}
        handleAddMoreCandidateDragLeave={handleAddMoreCandidateDragLeave}
        handleAddMoreCandidateDrop={handleAddMoreCandidateDrop}
        handleAddMoreCandidateFileUpload={handleAddMoreCandidateFileUpload}
        addMoreCandidateFiles={addMoreCandidateFiles}
        isAddMoreCandidateDragging={isAddMoreCandidateDragging}
        handleAddMoreCandidateDeleteFile={handleAddMoreCandidateDeleteFile}
        handleAddMoreCandidateClick={handleAddMoreCandidateClick}
        isLoading={isLoading}
        isJem={false}
        // disabled={addMoreCandidateFiles?.length >= 1}
        disabled={isLoading}
        buttonDisabled={isLoading}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <DialogCandidateHub
        open={backGroundprocess.open}
        // icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Processing"
        titlepadding={"0px 0px 16px"}
        handleClose={handlebackGroundWarningClose}
        footer={<BackGroundFooter />}
        content={
          "A background process is in progress. Please wait a few minutes while it completes."
        }
      />
      <DialogCandidateHub
        open={saveEditData.open}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Save to JEM"
        handleClose={handleSaveCandidate}
        footer={<Footer />}
        titlepadding={"0px 0px 16px"}
        content={
          "You have unsaved changes. If you leave this page, your changes will be lost. Are you sure you want to proceed?"
        }
      />

      {!open && (
        <ChatBotLabelText
          title={"My name is Hailey. Ask me about this Job/Candidate"}
          chatBotData={chatBotData}
          handleToggleDrawer={handleToggleDrawer}
        />
      )}
    </CustomDiv>
  );
}
